import { Minus, PackageX, Plus, RotateCcw, ShieldCheck, Truck } from "lucide-react";
import Reveal from "@/components/Reveal";
import { PRODUCT_IMAGE, LIFESTYLE_IMAGE } from "@/data";

export default function Shop({ product, variant, stock, selected, setSelected, activeImage, setActiveImage, qty, setQty, onAdd, onBuy }) {
  const shown = activeImage || PRODUCT_IMAGE;
  const price = variant.price.toFixed(2).replace(".", ",");
  const available = stock[variant.id] ?? null;
  const soldOut = available === 0;
  const lowStock = available !== null && available > 0 && available <= 3;
  return (
    <section className="vf-section" id="product">
      <div className="vf-breadcrumbs" data-testid="breadcrumbs"><a href="#top">Accueil</a><span>›</span><a href="#product">Fitness & bien-être</a><span>›</span><b>Plateformes vibrantes</b></div>
      <Reveal className="vf-shop-head">
        <p className="vf-kicker">La plateforme</p>
        <h2 className="vf-h2">Une seule machine.<br /><em>Trois façons de vous faire du bien.</em></h2>
      </Reveal>
      <div className="vf-shop">
        <Reveal className="vf-gallery" delay={0.1}>
          <div className="vf-thumbs">
            <button className={shown === PRODUCT_IMAGE ? "active" : ""} onClick={() => setActiveImage(PRODUCT_IMAGE)} data-testid="product-thumbnail-main"><img src={PRODUCT_IMAGE} alt="Vue principale" /></button>
            <button className={shown === LIFESTYLE_IMAGE ? "active" : ""} onClick={() => setActiveImage(LIFESTYLE_IMAGE)} data-testid="product-thumbnail-lifestyle"><img src={LIFESTYLE_IMAGE} alt="Utilisation à domicile" /></button>
            <button onClick={() => setActiveImage(PRODUCT_IMAGE)} data-testid="product-thumbnail-detail"><img src={PRODUCT_IMAGE} alt="Détail produit" /></button>
          </div>
          <div className="vf-main-img">
            <img src={shown} alt="Plateforme vibrante VibeFit" data-testid="main-product-image" />
            <button className="vf-zoom" data-testid="zoom-product-button">⌕ Agrandir</button>
          </div>
        </Reveal>
        <Reveal className="vf-info" delay={0.2}>
          <p className="vf-brand">VibeFit</p>
          <h3 className="vf-product-title" data-testid="product-title">{product.name}</h3>
          <div className="vf-rating-line">
            <span className="vf-stars">★★★★★</span>
            <a href="#reviews" data-testid="product-rating-link">{product.rating} ({product.review_count} évaluations)</a>
            <span className="vf-sep">|</span><span>Questions et réponses</span>
          </div>
          <p className="vf-sales">★ Plus de 100 achetées le mois dernier</p>
          <div className="vf-price-row">
            <span className="vf-old-price">249,00 €</span>
            <strong className="vf-price" data-testid="product-price">{price} €</strong>
            <span className="vf-promo">-20 %</span>
          </div>
          <p className="vf-install">Ou payez en 4 fois sans frais avec notre partenaire de paiement</p>
          <div className="vf-variants-block">
            <b>Couleur : <span>{variant.name}</span></b>
            <div className="vf-variants">
              {product.variants.map((v) => (
                <button key={v.id} className={`vf-variant ${selected === v.id ? "selected" : ""} ${stock[v.id] === 0 ? "sold-out" : ""}`} onClick={() => setSelected(v.id)} data-testid={`product-variant-${v.id}-button`}>
                  <span className={`vf-swatch ${v.id}`} />
                  <span>{v.name}</span>
                  <small>{stock[v.id] === 0 ? "Épuisé" : `${v.price} €`}</small>
                </button>
              ))}
            </div>
          </div>
          <div className="vf-delivery">
            <div><Truck size={20} /><p><b>Livraison GRATUITE</b><span>Recevez-la entre <strong>mardi 24 et jeudi 26</strong></span></p></div>
            <div>
              {soldOut ? <PackageX size={20} /> : <ShieldCheck size={20} />}
              <p data-testid="product-stock-status">
                {soldOut && <><b className="vf-stock-out">Rupture de stock</b><span>Ce coloris revient très bientôt</span></>}
                {lowStock && <><b className="vf-stock-low">Plus que {available} en stock</b><span>Expédiée par VibeFit</span></>}
                {!soldOut && !lowStock && <><b>En stock</b><span>Expédiée par VibeFit</span></>}
              </p>
            </div>
          </div>
          <div className="vf-buy-row">
            <div className="vf-qty">
              <button onClick={() => setQty(Math.max(1, qty - 1))} data-testid="product-decrease-quantity" aria-label="Diminuer" disabled={soldOut}><Minus size={14} /></button>
              <span data-testid="product-quantity">{qty}</span>
              <button onClick={() => setQty(qty + 1)} data-testid="product-increase-quantity" aria-label="Augmenter" disabled={soldOut}><Plus size={14} /></button>
            </div>
            <button className="vf-add" onClick={onAdd} disabled={soldOut} data-testid="add-to-cart-button">{soldOut ? "Rupture de stock" : "Ajouter au panier"}</button>
            <button className="vf-buy" onClick={onBuy} disabled={soldOut} data-testid="buy-now-button">Acheter maintenant</button>
          </div>
          <div className="vf-assurances">
            <span><RotateCcw size={15} /> Retour gratuit</span>
            <span><ShieldCheck size={15} /> Garantie 2 ans</span>
            <span><Truck size={15} /> Livraison suivie</span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
